import { GridAction } from '@eforall/dashboard';
import { Facilitator } from '@interfaces';

export function getActions() {

	const actions: GridAction<Facilitator>[] = [];

	return actions;
}